export default __webpack_public_path__ + "static/media/md-card-bg-business-analyst.0e217592.png";